var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrisConnectAdp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c33f41;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.86,187.35H296.59l-.1,21.59a62,62,0,0,0-47.05-21.55h-66L110,312.63h49.8l15.72-27h33v27l40.94,0A62,62,0,0,0,296.49,291v21.59h42.61v-27h1.77a49.14,49.14,0,0,0,0-98.28Zm0,82.79H323.59v27H312.08v-27H292.2A47.08,47.08,0,0,1,249.44,297l-25.45.1v-27H166.22l-15.94,27H137.67L193,203h56.44a47.09,47.09,0,0,1,46.77,40.14l15.87,0V202.84h28.78a33.65,33.65,0,0,1,0,67.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.44,214.31H235.5v15.32l13.94,0a20.24,20.24,0,1,1,0,40.47s-13.94-.21-13.94,0v15.51l13.94.05a35.69,35.69,0,1,0,0-71.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.86,214.37H323.59v15.37l17.27,0a6.73,6.73,0,0,1,0,13.46H323.59v15.35h17.27a22.1,22.1,0,0,0,0-44.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "208.5 243.13 181.94 243.13 172.86 258.62 223.99 258.62 223.99 214.36 208.5 214.36 208.5 243.13 208.5 243.13"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrisConnectAdp);
export default __webpack_public_path__ + "static/media/HRIS-connect-ADP.ed5eaf86e93c78d7cb31be26f6d51ae7.svg";
export { ForwardRef as ReactComponent };